import register from '@kpsys/angularjs-register';
import {MailerDataService} from './mailer-data.service';
import {MailerService} from './mailer.service';

export default register('portaro.shared.mailer')
    .service(MailerDataService.serviceName, MailerDataService)
    .service(MailerService.serviceName, MailerService)
    .name()